module.exports = "<div> <carousel-banner ng-if=$ctrl.dbData.isCarousel cb-items=$ctrl.dbData.items cb-name=$ctrl.dbName></carousel-banner> <div ng-if=!$ctrl.dbData.isCarousel> <a href=\"{{$ctrl.dbData.items[0].url ? $ctrl.dbData.items[0].url : '#'}}\" title={{$ctrl.dbData.items[0].title}}> <img ng-src={{$ctrl.dbData.items[0].imageUrl}} class=\"img-responsive img-margin\"> </a> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/banners/dynamic-banner/templates/dynamic-banner-base.view.html
 ** module id = 873
 ** module chunks = 7
 **/